"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorGraphLineDefault = exports.ColorGraphBarDefault = exports.ColorGraphTextDefault = exports.ColorSubjectDroppedOut = exports.ColorSubjectCompleted = exports.ColorSubjectOngoing = exports.ColorSubjectScreeningFailed = exports.ColorSubjectScreening = exports.ColorSubjectEnroll = exports.ColorSubjectRegistration = exports.ColorsDefault = void 0;
exports.ColorsDefault = ["#e8c1a0", "#f47560", "#f1e15b", "#e8a838", "#61cdbb", "#97e3d5"];
exports.ColorSubjectRegistration = "#8DD8FF";
exports.ColorSubjectEnroll = "#51BEFF";
exports.ColorSubjectScreening = "#0094FF";
exports.ColorSubjectScreeningFailed = "#FF8A00";
exports.ColorSubjectOngoing = "#0068C8";
exports.ColorSubjectCompleted = "#1F3F5E";
exports.ColorSubjectDroppedOut = "#FF1066";
exports.ColorGraphTextDefault = "#000000";
exports.ColorGraphBarDefault = "#cfcfcf";
exports.ColorGraphLineDefault = "#000000";
//# sourceMappingURL=color.js.map